import { styled } from '@mui/material'

export const PageContentWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(11.25, 2, 0, 2),
    width: '100%',
    height: '100%',
}))
